import classNames from "classnames";
import React, { useCallback, useEffect, useRef, useState } from "react";

import UserIcon from "../../assets/icons/user_icon.svg";
import ShaiaCreate from "../../assets/shaia_create.png";

export const GenericChat = ({ message, isEditorOn, createMarkup, handleOption }) => {
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(null);  
  const messageContainerRef = useRef(null);

  const clickHandler = useCallback((event) => {
    const index = parseInt(event.target.dataset.index, 10);
    setSelectedOptionIndex(index);  
    const content = `La opción ${Number(index) + 1}`;
    event.target.textContent = event.target.textContent === "Seleccionar" ? "Seleccionado" : "Seleccionar";
    handleOption && handleOption(content);
  }, [handleOption]);

  useEffect(() => {
    const optionCards = messageContainerRef.current?.querySelectorAll('.option-card');
    const buttons = messageContainerRef.current?.querySelectorAll('.chat_option-button');

    if (optionCards) {
      optionCards.forEach((card, index) => {
        card.dataset.index = index; // Asigna el índice al dataset para acceso en el handler
        card.className = classNames('option-card', {
          'selected': index === selectedOptionIndex
        }); // Aplica la clase selected basada en el estado
      });
    }


    if (buttons) {
      buttons.forEach((button, index) => {
        button.textContent = index === selectedOptionIndex ? "Seleccionado" : "Seleccionar";  // Actualiza el texto basado en el estado
        button.dataset.index = index; // Asigna el índice a dataset para acceso en el handler
        button.className = classNames("chat_option-button",{
          'selected': index === selectedOptionIndex
        }); // Aplica la clase selected basada en el estado
        button.addEventListener('click', clickHandler);
      });
    }

    return () => {
      if (buttons) {
        buttons.forEach((button) => {
          button.removeEventListener('click', clickHandler);
        });
      }
    };
  }, [message, clickHandler, selectedOptionIndex]);
  return (
    <div
      className={`max-w-full chat_conversation-thread-${
        message?.role === "user" || message?.type === "human" ? "user" : "ai"
      }`}
    >
      <div className={classNames("bubble-wrapper")}>
        <div
          className={`chat_bubble-${
            message?.role === "user" || message?.type === "human" ||  message?.role === "human"
              ? "user"
              : "ai"
          }`}
        >
          <div
            className={`bubble-message ${isEditorOn ? "xl:px-2" : "xl:px-10"}`}
          >
            {["user", "assistant", "ai", "human"].includes(
              message?.role || message?.type
            ) && (
              <div
                className="chat-message-content"
                ref={messageContainerRef}
                dangerouslySetInnerHTML={createMarkup(
                  message?.content || message?.data?.content
                )}
              />
            )}
          </div>
        </div>
      </div>
      <div
        className={`chat_avatar-${
          message?.role === "user" || message?.type === "human" || message?.role === "human"
            ? "user p-1"
            : "ai items-start"
        }`}
      >
        {(message?.role === "user" || message?.type === "human" || message?.role === "human") && (
          <img src={UserIcon} alt="Tú" />
        )}
        {(message?.role === "assistant" || message?.type === "ai") && (
          <img src={ShaiaCreate} alt="Sha.ia" />
        )}
      </div>
    </div>
  );
};

export default GenericChat;
